import {useKeycloak} from "@react-keycloak/web";
import {Button, Col, Form, Row, Spin} from "antd";
import {useHistory} from "react-router-dom";
import './style.scss'
import {
    manageWealthText, welcomeClipPathImg,
    welcomePageQR,
    welcomePageQRText, welcomeText,
} from '../../../AppImageConst';
import {useEffect} from 'react';

const CustomerWelcomePage = () => {
    const redirectUri: string | undefined = process.env.REDIRECT_URI ? process.env.REDIRECT_URI : "http://localhost:3000/";
    const {keycloak} = useKeycloak();
    const customerHomePage = "workflow/customer/dashboard";
    let history = useHistory();
    const loginPage = (e: any) => {
        if (keycloak && !keycloak.authenticated) {
            keycloak.login({redirectUri: `${redirectUri}${customerHomePage}`});
        }
    }

    const signUp = (e: any) => {
        history.push(`/signup`)
    }

    // const logout = (e: any) => {
    //     if (keycloak.authenticated) {
    //         keycloak.logout({redirectUri: `${redirectUri}workflow/main-home-page`});
    //     }
    // }

    useEffect(() => {
        if (keycloak && keycloak.authenticated) {
            history.push(`/workflow/customer/dashboard`)
        }
    }, [])

    return <>
        {/*{keycloak.authenticated ? <Tooltip title="Sign Out"><FloatButton icon={<LogoutOutlined/>} type="primary" onClick={logout}/></Tooltip> : <></>}*/}
        {keycloak.authenticated ? <div className="loader-container">
                <Spin size="large" tip="Loading"></Spin>
            </div> :

            <div className='welcome_screen new-welcome-screen-bg'>
                <Row gutter={0} className='main-row'>
                    <Col lg={12} md={{span: 12}} sm={{span: 24}} xs={{span: 24}}  className='left-side-main-container'>
                        <Row gutter={0} className='main-row'>
                            <Col span={24}>
                                <img src={welcomeClipPathImg} style={{width: '100%'}} alt="logo"/>
                            </Col>
                            <Col span={24} md={24} sm={24} className='left-side-title-container'>
                                <img src={welcomePageQR} className={'w-35'} style={{marginTop:24, marginBottom:20}} alt="logo"/>
                                <img src={welcomePageQRText} className={'w-70'} alt="logo"/>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={12} md={{span: 12}} sm={{span: 24}} xs={{span: 24}}  >
                        <div className='right-side-col'>
                            <div className='right_side_container'>
                                <div>
                                    <img src={welcomeText} style={{width: '100%'}} alt="logo"/>
                                </div>
                                <div>
                                    <img src={manageWealthText} style={{width: '100%'}} alt="logo"/>
                                </div>

                                <Row gutter={16}>
                                    <Col span={24} className='sign-in-btn-container'>
                                        <Form.Item className='form-item-btn'>
                                            <Button className='custom-sign-in-btn-primary' type="ghost"
                                                    onClick={loginPage}>
                                                Sign in
                                            </Button>
                                        </Form.Item>
                                    </Col>

                                    <Col span={24} className='sign-up-btn'>
                                        <Form.Item className='form-item-btn'>
                                            <Button className='custom-sign-up-btn-primary' type="primary"
                                                    onClick={signUp}>
                                                Sign up
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>}
    </>
}

export default CustomerWelcomePage;
